import type { Action } from '@ngrx/store';
import type { ProjectResourceChanges } from 'core/http/project/resource-updates/resource-updates.service';
import { createReducer, on } from '@ngrx/store';
import * as ProjectResourcesActions from './project-resources.actions';

export interface ProjectResourcesState {
  resources: ProjectResourceChanges;
  isLoaded: boolean;
  loading: boolean;
  error: Error | null;
}

export const initialProjectResourcesState: ProjectResourcesState = {
  resources: {} as ProjectResourceChanges,
  isLoaded: false,
  loading: false,
  error: null,
};

const reducer = createReducer(
  initialProjectResourcesState,
  on(ProjectResourcesActions.saveProjectResources, (state, { resources }) => ({ ...state, resources })),
  on(ProjectResourcesActions.getProjectResources, state => ({ ...state, loading: true, error: null })),
  on(ProjectResourcesActions.markProjectResourcesLoaded, state => ({ ...state, isLoaded: true, error: null })),
  on(ProjectResourcesActions.setLoading, (state, { value }) => ({ ...state, loading: value })),
  on(ProjectResourcesActions.setError, (state, { value }) => ({ ...state, error: value, loading: false })),
);

export function projectResourcesReducer(state: ProjectResourcesState | undefined, action: Action): ProjectResourcesState {
  return reducer(state, action);
}
